import React, {Component} from 'react';
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {Alert} from "reactstrap";
import appRoutes from "../../../../../../appRoutes";
import AdvancedList from "./components/AdvancedList";

class Advanced extends Component {
  render() {
    const {plan} = this.props;
    const {analysis} = this.props.match.params;

    return (
      <div className="m-3 h-100">
        {!plan.analysis.advanced ? <Alert color="warning" className="text-center">
          <span>Brak dostępu do zaawansowanej analizy w Twoim planie. <Link to={appRoutes.users.plan} style={{fontSize: '16px'}}>Kliknij, aby zmienić plan</Link></span>
        </Alert> : <AdvancedList analysis={parseInt(analysis)} />}
      </div>
    );
  }
}

Advanced.propTypes = {};

function mapStateToProps(state) {
  return {
    plan: state.user.userPlan.plan,
  }
}

export default connect(mapStateToProps)(Advanced);